import React, {
  useState,
  useEffect,
  useRef,
  lazy,
  Suspense,
  useCallback,
} from "react";
import axios from "axios";
import { toast } from "sonner";
import "./generatenumber.css";
import "odometer/themes/odometer-theme-default.css";
const Odometer = lazy(() => import("react-odometerjs"));

const GenerateNumber = () => {
  const [countData, setCountData] = useState({ value: null, suffix: "" });
  const timeoutRef = useRef(null);

  const updateNumberDisplay = useCallback((num) => {
    const absNumber = Math.abs(num);
    let suffix = "";
    let value = absNumber;

    if (absNumber >= 1000000000000) {
      suffix = " Trillion +";
      value = absNumber / 1000000000000;
    } else if (absNumber >= 1000000000) {
      suffix = " Billion +";
      value = absNumber / 1000000000;
    } else if (absNumber >= 1000000) {
      suffix = " Million +";
      value = absNumber / 1000000;
    }

    setCountData((prev) =>
      prev.value === value && prev.suffix === suffix
        ? prev
        : { value: Math.round(value * 1000) / 1000, suffix }
    );
  }, []);

  const fetchData = async () => {
    try {
      const { data } = await axios.get(process.env.REACT_APP_WEBSITE_COUNT_ULR);
      if (data?.count !== undefined) {
        updateNumberDisplay(data.count);
      }
    } catch (error) {
      toast.error(error?.message || "Unable to fetch real-time updates");
    }
  };

  useEffect(() => {
    const getRandomInterval = () =>
      (Math.floor(Math.random() * 31) + 30) * 1000;

    const scheduleFetch = () => {
      fetchData();
      timeoutRef.current = setTimeout(scheduleFetch, getRandomInterval());
    };
    scheduleFetch();
    return () => clearTimeout(timeoutRef.current);
  }, [updateNumberDisplay]);

  if (countData.value === null) return <div>...</div>;

  return (
    <div className="number-box">
      <Suspense fallback={<div>...</div>}>
        <Odometer value={countData.value} format="(,ddd).ddd" duration={1000} />
      </Suspense>
      <span>{countData.suffix}</span>
    </div>
  );
};

export default React.memo(GenerateNumber);
